import React from "react";
import {
  Datagrid,
  FunctionField,
  ResourceContextProvider,
  TextField,
} from "react-admin";
import moment from "moment/moment";
import CustomStatusField from "../../parents/components/CustomStatusField";
import CustomDateField from "../../../components/CustomDateField";
import UpdatedByField from "../../../components/UpdatedByField";
import { PaddingDenseStyledList } from "../../../components/ListWrapper";

interface IStudentSubsidyHistoryTable {
  studentId: number;
  activeStudentSubsidyId: number;
}

const StudentSubsidyHistoryTable = ({
  studentId,
  activeStudentSubsidyId,
}: IStudentSubsidyHistoryTable) => {
  const dateFormat = "DD / MM / YYYY";

  return (
    <ResourceContextProvider value="studentSubsidies">
      <PaddingDenseStyledList
        basePath="/studentSubsidies"
        actions={false}
        exporter={false}
        hasCreate={false}
        filters={null}
        filter={{
          StudentId: studentId,
        }}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        title=" "
      >
        <Datagrid>
          <FunctionField
            label="Period"
            render={(record: any) =>
              `${moment
                .utc(record.periodStartDate)
                .format(dateFormat)} - ${moment
                .utc(record.periodEndDate)
                .format(dateFormat)}`
            }
          />
          <FunctionField
            label="Subsidy Percentage"
            render={(record: any) => `${record.subsidyPercentage}%`}
          />
          <TextField source="remark" emptyText="-" />
          <FunctionField
            label="Status"
            render={(record: any) => {
              if (!activeStudentSubsidyId) return "-";

              return activeStudentSubsidyId === record.id ? (
                <CustomStatusField
                  title="Active"
                  key={`student-subsidy-status-key-${record.id}`}
                />
              ) : (
                <CustomStatusField
                  title="Archive"
                  key={`student-subsidy-status-key-${record.id}`}
                />
              );
            }}
          />
          <CustomDateField
            source="createdAt"
            label="Created At"
            emptyText="-"
            isDateTime
          />
          <FunctionField
            label="Created By"
            render={(record: any) => (
              <>
                {record.updatedBy === null ? (
                  "-"
                ) : (
                  <UpdatedByField data={record.updatedBy} />
                )}
              </>
            )}
          />
        </Datagrid>
      </PaddingDenseStyledList>
    </ResourceContextProvider>
  );
};

export default StudentSubsidyHistoryTable;
